import {
  FETCH_VPA_REQUEST,
  FETCH_VPA_SUCCESS,
  FETCH_VPA_FAILURE,
  CLEAR_STORE,
  UPDATE_VPA_DETAIL_REQUEST,
  UPDATE_VPA_DETAIL_SUCCESS,
  UPDATE_VPA_DETAIL_FAILURE,
  DELETE_VPA_REQUEST,
  DELETE_VPA_SUCCESS,
  DELETE_VPA_FAILURE,
} from './vpaActions';

export interface VpaState {
  loading: boolean;
  vpa: any;
  error: string | null;
  vpa_details: any;
}

const initialState: VpaState = {
  loading: true,
  vpa: null,
  error: null,
  vpa_details: null,
};

interface VpaAction {
  type: string;
  payload?: any;
  error?: any;
}

const vpaReducer = (state: VpaState = initialState, action: VpaAction): VpaState => {
  switch (action.type) {
    case FETCH_VPA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_VPA_SUCCESS:
      return {
        ...state,
        loading: false,
        vpa: action.payload,
      };
    case FETCH_VPA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case UPDATE_VPA_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_VPA_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        vpa_details: action.payload,
      };
    case UPDATE_VPA_DETAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case DELETE_VPA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_VPA_SUCCESS: {
      const current = state.vpa;
      if (!current || !Array.isArray(current) || !current[0] || !('vpa' in current[0])) {
        return state;
      }
      const updatedFirst = {
        ...current[0],
        vpa: current[0].vpa.filter((v: any) => v.vpaId !== action.payload),
      };
      return {
        ...state,
        loading: false,
        vpa: [updatedFirst, ...current.slice(1)],
      };
    }
    case DELETE_VPA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error ?? null,
      };
    case CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
};

export default vpaReducer;

